/* @ngInject */
function PreviewAttachmentController ($sce, $state, $q, $timeout, $cookies, SegmentService, ModalService, SliderService, AssetService, Utils, CONSTANTS, ArtsService, UdsModalService) {
  const getDownloadDialogController = () => $q.when(import('../../../arts/dialogs/download/download-dialog.controller'))
  const getTemplateSuggestionsDialogController = () => $q.when(import('../../../arts/dialogs/template-suggestions/template-suggestions-dialog.controller'))

  const pdfjsLib = require('pdfjs-dist')
  // The workerSrc property shall be specified.
  pdfjsLib.GlobalWorkerOptions.workerSrc = new URL('pdfjs-dist/build/pdf.worker.min.mjs', import.meta.url).toString()

  var ctrl = this
  ctrl.previewUrl = ''
  ctrl.deskfyPreview = AssetService.getDeskfyDefaultPreviewFormats()
  ctrl.isShowing = false
  ctrl.imageZoom = 1
  ctrl.slider = false
  ctrl.loadingPreview = false
  ctrl.isZoomOut = false

  ctrl.imageScaleRatio = 0.25
  ctrl.maxImageScale = 4

  ctrl.panConfig = {
    elViewport: null,
    elCanvas: null,
    offset: { x: 0, y: 0 },
    isPan: null,
    isVertical: false,
    isHorizontal: false,
    imgSizeDiffX: 0,
    imgSizeDiffY: 0
  }

  const api = {
    getDownloadDialogController,
    getTemplateSuggestionsDialogController,
    _showPreviewContainer,
    _hidePreviewContainer,
    _prepareGooglePreview,
    _getPosition,
    _stopMedia,
    _preparePdfPreview,
    _updateImageScale,
    _getPreviewElAndDimensions,
    _setElementScale,
    _handleImagePanning,
    _getImagePanningConfigs,
    _handlePanningScale,
    _subtract,
    _panStart,
    _panMove,
    _panEnd,
    _setPreviewStyleTranslate,
    _checkVerticalOverflow,
    _checkHorizontalOverflow
  }

  ctrl.$onInit = function () {
    $timeout(function () {
      if (ctrl.slider) { SliderService.setState(ctrl.slider, 'toggle-lock', false) }
      ctrl.showing = false
    })
  }

  ctrl.$doCheck = function () {
    if (ctrl.show && !ctrl.isShowing && ctrl.attachment && ctrl.attachment.src) {
      if (ctrl.slider) {
        SliderService.setState(ctrl.slider, 'toggle-lock', true)
      }
      ctrl.isShowing = true
      ctrl.loadingPreview = false
      $timeout(() => {
        api._showPreviewContainer()
        if (ctrl.attachment.extension === 'pdf') {
          api._preparePdfPreview()
        } else {
          api._prepareGooglePreview()
        }
      })
    }
  }

  ctrl.zoomIn = function () {
    if (ctrl.imageZoom < ctrl.maxImageScale) {
      ctrl.imageZoom = ctrl.imageZoom + ctrl.imageScaleRatio
      api._updateImageScale()
    }
  }

  ctrl.zoomOut = function () {
    if (ctrl.imageZoom > ctrl.imageScaleRatio) {
      ctrl.imageZoom = ctrl.imageZoom - ctrl.imageScaleRatio
      ctrl.isZoomOut = true
      api._updateImageScale()
    }
  }

  ctrl.closePreview = function () {
    ctrl.imageZoom = 1
    api._hidePreviewContainer()
    $timeout(function () {
      ModalService.refresh()
    }, 500, false)
  }
  ctrl.nextPage = false

  ctrl.next = function () {
    ctrl.nextPage = true

    if (ctrl.attachment.showingLayerIndex >= ctrl.attachment.layersId.length - 1) {
      return
    }

    _setNewThumbnailSrc(++ctrl.attachment.showingLayerIndex)
  }
  ctrl.prev = function () {
    ctrl.nextPage = false

    if (ctrl.attachment.showingLayerIndex <= 0) {
      return
    }

    _setNewThumbnailSrc(--ctrl.attachment.showingLayerIndex)
  }

  function _setNewThumbnailSrc (index) {
    const fileView = ctrl.mActions.getThumbnailSrc(ctrl.art.id, ctrl.attachment.layersId[index])

    ctrl.attachment.src = {
      thumbnail: fileView,
      original: fileView
    }
  }

  ctrl.getImageScalePercentage = (imageScale = 0) => {
    const percentage = Math.round(imageScale * 100)

    return `${percentage}%`
  }

  ctrl.downloadAttachment = function () {
    if (ctrl.art) {
      ctrl.closePreview()

      const url = Utils.fnReplaceStringParams(CONSTANTS.URL_ARTS_DOWNLOAD, [ctrl.art.id])

      ctrl.art.details = {
        suggestions: ctrl.art.suggestions
      }
      if (ctrl.art.isCustomizable) {
        return api.getDownloadDialogController().then(({ DownloadDialogController }) => {
          const downloadDialog = UdsModalService.createModal({
            controller: DownloadDialogController,
            modalName: 'downloadDialog',
            data: {
              _iArtId: ctrl.art.id,
              _customizationLevel: ctrl.art.customizationLevel,
              _sDownloadOption: ctrl.art.downloadOption,
              _iProductId: ctrl.art.productId,
              _oTemplate: ctrl.art
            }
          })

          downloadDialog.open()
        })
      }

      return Utils.downloadFile(url)
        .then(() => {
          if (ctrl.art.suggestions) {
            api.getTemplateSuggestionsDialogController().then(({ TemplateSuggestionsDialogController }) => {
              ModalService.showModal({
                templateId: 'templateSuggestions.html',
                templateUrl: '/arts/dialogs/template-suggestions/template-suggestions-dialog.html?$$REVISION$$',
                controller: TemplateSuggestionsDialogController,
                destroyable: true,
                data: {
                  _sSuggestions: ctrl.art.suggestions,
                  _bIsPrintInstruction: ctrl.art.product && ctrl.art.product.type === 'PRINTABLE'
                }
              })
            })
          }

          $q.all([
            ArtsService.getArtDetailById(ctrl.art.id),
            ArtsService.getInfosBusinessData(ctrl.art.id)
          ]).then(([art, businessDataInfo]) => {
            const productValue = !!document.querySelector('#canvas_group [data-product]')
            SegmentService.track('downloaded-art', {
              art_id: ctrl.art.id,
              photoframes: 0,
              permission: 'download',
              type: 'only_download',
              template_id: art.baseTemplateId,
              place: 'Widget',
              element_hyperlink: art.hyperlinks,
              format_type: ctrl.art.product.type.toLowerCase(),
              business_data: businessDataInfo.hasPlaceholdersSaved,
              video: art.hasVideo,
              product: productValue
            })
          })
        })
    }

    if (ctrl.mActions && ctrl.mActions.download) {
      ctrl.mActions.download(ctrl.attachment, function () {
        return ctrl.attachment.name
      })
    }
  }

  ctrl._handleCustomizeTemplateClick = () => {
    $state.go('customizeTemplate', {
      templateId: ctrl.art.id,
      from: $state.current.name,
      fromParams: $state.params
    })
  }

  function _preparePdfPreview () {
    ctrl.mActions.downloadWithProgress(ctrl.attachment.id,
      function (e) {},
      async function (blob) {
        const urlCreator = window.URL || window.webkitURL
        const pdfDoc = await pdfjsLib.getDocument({
          url: urlCreator.createObjectURL(blob),
          disableStream: true,
          disableAutoFetch: true
        }).promise

        const container = document.querySelector('.preview-pdf')
        const width = container.getBoundingClientRect().width - 100

        Array.from({ length: pdfDoc.numPages }).forEach(async (_, index) => {
          const numPage = index + 1
          const page = await pdfDoc.getPage(numPage)

          const scale = width / page.getViewport({ scale: 1.0 }).width
          const viewport = page.getViewport({ scale })

          const canvas = document.createElement('canvas')
          canvas.width = viewport.width
          canvas.height = viewport.height
          container.appendChild(canvas)

          page.render({
            canvasContext: canvas.getContext('2d'),
            viewport
          })
        })
        ctrl.loadingPreview = false
      },
      {
        isTempFile: isNaN(ctrl.attachment.id),
        query: {
          jwt: $cookies.get('jwt')
        },
        externalUrl: true
      })
  }

  function _getPosition (element) {
    var viewportOffset = element.getBoundingClientRect()
    var top = viewportOffset.top
    var left = viewportOffset.left

    return { x: left, y: top }
  }

  function _hidePreviewContainer () {
    jQuery('.ui.page.active').css('overflow-y', 'auto')
    var preview = document.getElementById('preview-attachment-' + ctrl.attachment.id)
    if (ctrl.slider) { SliderService.setState(ctrl.slider, 'toggle-lock', false) }
    ctrl.isShowing = false
    ctrl.show = false
    preview.style.opacity = 0
    if (ctrl.attachment.extension !== 'pdf') {
      api._stopMedia()
    }
  }

  function _stopMedia () {
    const mediaType = ctrl.attachment.type.toLowerCase()
    const mediaElement = document.getElementById(mediaType + '-preview-' + ctrl.attachment.id)

    if (!mediaElement) {
      return
    }
    mediaElement.pause()
  }

  function _showPreviewContainer () {
    jQuery('.ui.page.active').css('overflow-y', 'hidden')
    ModalService.refresh()
    const preview = document.getElementById('preview-attachment-' + ctrl.attachment.id)
    preview.style.top = 0
    preview.style.left = 0
    preview.style.opacity = 1
    const position = api._getPosition(preview)

    preview.style.top = '-' + position.y + 'px'
    preview.style.left = '-' + position.x + 'px'
  }

  function _prepareGooglePreview () {
    if (!ctrl.deskfyPreview.supportedExtensions.includes(ctrl.attachment.extension)) {
      let assetUrl
      if (isNaN(ctrl.attachment.id)) {
        assetUrl = Utils.fnReplaceStringParams(CONSTANTS.URL_TEMPORARY_FILES_UUID, [ctrl.assetToken])
      } else if (ctrl.assetToken === 'briefing') {
        assetUrl = Utils.fnReplaceStringParams(CONSTANTS.URL_EXTERNAL_BRIEFINGS_ATTACHMENT_DOWNLOAD, [ctrl.attachment.id])
      } else {
        assetUrl = Utils.fnReplaceStringParams(CONSTANTS.URL_EXTERNAL_ASSET_UUID_DOWNLOAD, [ctrl.assetToken])
      }
      const previewUrl = Utils.fnReplaceStringParams(CONSTANTS.BASE_GOOGLE_PREVIEW_URL, [assetUrl])
      ctrl.previewUrl = $sce.trustAsResourceUrl(previewUrl)
    }
  }

  function _updateImageScale () {
    const { imageEl, width, height } = api._getPreviewElAndDimensions()

    api._setElementScale(imageEl, width, height)

    api._handleImagePanning(api._checkVerticalOverflow(imageEl), api._checkHorizontalOverflow(imageEl))
  }

  function _getPreviewElAndDimensions () {
    const imageEl = document.querySelector('[data-preview="image"]')
    const wrapperEl = document.querySelector('[data-preview="wrapper"]')

    return {
      imageEl,
      wrapperEl,
      width: imageEl.naturalWidth + 'px',
      height: imageEl.naturalHeight + 'px'
    }
  }

  function _setElementScale (element, width, height) {
    element.style.width = width
    element.style.height = height
    element.style.transform = 'scale(' + ctrl.imageZoom + ', ' + ctrl.imageZoom + ')'
  }

  function _handleImagePanning (isVertical, isHorizontal) {
    api._getImagePanningConfigs(isVertical, isHorizontal)
    api._handlePanningScale()

    if (isVertical || isHorizontal) {
      ctrl.panConfig.elViewport.addEventListener('pointerdown', api._panStart)
      ctrl.panConfig.elViewport.addEventListener('pointermove', api._panMove)
      ctrl.panConfig.elViewport.addEventListener('pointerup', api._panEnd)
    } else {
      ctrl.panConfig.offset.x = 0
      ctrl.panConfig.offset.y = 0
      ctrl.panConfig.elViewport.removeEventListener('pointerdown', api._panStart)
      ctrl.panConfig.elViewport.removeEventListener('pointermove', api._panMove)
      ctrl.panConfig.elViewport.removeEventListener('pointerup', api._panEnd)
    }
  };

  function _getImagePanningConfigs (isVertical, isHorizontal) {
    ctrl.panConfig.elViewport = document.querySelector('[data-preview="container"]')
    ctrl.panConfig.elCanvas = document.querySelector('[data-preview="image"]')
    ctrl.panConfig.isPan = false
    ctrl.panConfig.isHorizontal = isHorizontal
    ctrl.panConfig.isVertical = isVertical
    ctrl.panConfig.imgSizeDiffX = ctrl.panConfig.elCanvas.width * ctrl.imageScaleRatio
    ctrl.panConfig.imgSizeDiffY = ctrl.panConfig.elCanvas.height * ctrl.imageScaleRatio
  }

  function _handlePanningScale () {
    if (ctrl.isZoomOut) {
      if (!ctrl.panConfig.isHorizontal) {
        ctrl.panConfig.offset.x = 0
      }

      if (!ctrl.panConfig.isVertical) {
        ctrl.panConfig.offset.y = 0
      }

      if (ctrl.panConfig.offset.x !== 0) {
        ctrl.panConfig.offset.x = api._subtract(ctrl.panConfig.offset.x, ctrl.panConfig.imgSizeDiffX / 2)
      }

      if (ctrl.panConfig.offset.y !== 0) {
        ctrl.panConfig.offset.y = api._subtract(ctrl.panConfig.offset.y, ctrl.panConfig.imgSizeDiffY / 2)
      }

      api._setPreviewStyleTranslate(ctrl.panConfig.offset.x, ctrl.panConfig.offset.y)
      ctrl.isZoomOut = false
    }
  }

  function _subtract (minuend = 0, subtrahend = 0) {
    const isNegative = Math.sign(minuend) === -1

    if (isNegative) {
      return minuend + subtrahend
    }

    return minuend - subtrahend
  }

  function _panStart (ev) {
    ev.preventDefault()
    ctrl.panConfig.isPan = true
  };

  function _panMove (ev) {
    if (!ctrl.panConfig.isPan) return

    if (ctrl.panConfig.isVertical) {
      const { elViewport, elCanvas } = ctrl.panConfig
      const maxHeightOffset = (elCanvas.height * ctrl.imageZoom - elViewport.offsetHeight) / 2
      const absY = Math.abs(ctrl.panConfig.offset.y + ev.movementY)

      if (absY <= maxHeightOffset) {
        ctrl.panConfig.offset.y += ev.movementY
      }
    }

    if (ctrl.panConfig.isHorizontal) {
      const { elViewport, elCanvas } = ctrl.panConfig
      const maxWidthOffset = (elCanvas.width * ctrl.imageZoom - elViewport.offsetWidth) / 2
      const absX = Math.abs(ctrl.panConfig.offset.x + ev.movementX)

      if (absX <= maxWidthOffset) {
        ctrl.panConfig.offset.x += ev.movementX
      }
    }

    api._setPreviewStyleTranslate(ctrl.panConfig.offset.x, ctrl.panConfig.offset.y)
  };

  function _panEnd () {
    ctrl.panConfig.isPan = false
  };

  function _setPreviewStyleTranslate (x, y) {
    const translateCoordinates = `${x}px ${y}px`
    ctrl.panConfig.elCanvas.style.translate = translateCoordinates
  }

  function _checkVerticalOverflow (elem) {
    const elemHeight = elem.getBoundingClientRect().height
    const parentWHeight = elem.parentElement.getBoundingClientRect().height

    return elemHeight > parentWHeight
  }

  function _checkHorizontalOverflow (elem) {
    const elemWidth = elem.getBoundingClientRect().width
    const parentWidth = elem.parentElement.getBoundingClientRect().width

    return elemWidth > parentWidth
  }
}

export { PreviewAttachmentController }
